import { Layers } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { gallery, waLink } from "@/content/site";
import { Reveal, SectionHead, Check, Arrow } from "@/components/apex/primitives";

const pick = (id) => gallery.find((g) => g.id === id) || gallery[0];

const Manifesto = () => {
  const { t, isRtl } = useLang();
  const m = t.manifesto;
  const imgA = pick("apex-interior-warm");
  const imgB = pick("apex-sculpted-facet");
  const stat = m.facts[2];
  const list = m.facts.filter((_, i) => i !== 2);

  return (
    <section data-testid="manifesto-section" className="relative py-14 sm:py-20">
      <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
        {/* الكولاج */}
        <Reveal>
          <div className="relative mx-auto max-w-[560px]" data-testid="manifesto-collage">
            <div className="ap-img aspect-[4/5] w-[72%]">
              <img
                src={imgA.src}
                alt={isRtl ? imgA.alt_ar : imgA.alt_en}
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="ap-img absolute bottom-[-8%] end-0 aspect-[3/4] w-[52%] border-[6px] border-[var(--cream)]">
              <img
                src={imgB.src}
                alt={isRtl ? imgB.alt_ar : imgB.alt_en}
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="ap-card group absolute end-[4%] top-[10%] flex items-center gap-4 px-5 py-4 shadow-[0_24px_50px_-28px_rgba(21,21,21,0.4)]">
              <span className="ap-icon h-12 w-12">
                <Layers className="h-5 w-5" strokeWidth={1.8} />
              </span>
              <span>
                <span className="ap-display block text-2xl text-[var(--text)]" dir="auto">
                  {stat.v}
                </span>
                <span className="block text-[13px] text-[var(--muted)]">{stat.k}</span>
              </span>
            </div>
          </div>
        </Reveal>

        {/* النص */}
        <div className="lg:ps-6">
          <SectionHead label={m.label} title={m.title} body={m.body} />

          <Reveal delay={0.1}>
            <div className="ap-card mt-8 p-6">
              <ul className="grid gap-3.5 sm:grid-cols-2">
                {list.map((f) => (
                  <Check key={f.k}>
                    <span className="font-semibold">{f.k}:</span>{" "}
                    <span dir="auto" className="text-[var(--muted)]">
                      {f.v}
                    </span>
                  </Check>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.16}>
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a href="#collections" data-testid="manifesto-cta" className="ap-btn">
                {t.hero.primary}
                <Arrow />
              </a>
              <a
                href={waLink(t.float.defaultMsg)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="manifesto-whatsapp"
                className="ap-btn-white"
              >
                {t.contact.wa}
                <Arrow />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
